export const WELL_INFO = 'WELL_INFO';
export const WELL_INFO_SUCCESS = 'WELL_INFO_SUCCESS';
export const WELL_INFO_ERROR = 'WELL_INFO_ERROR';

export const WELL_INFO_UPDATE = 'WELL_INFO_UPDATE';
export const WELL_INFO_UPDATE_SUCCESS = 'WELL_INFO_UPDATE_SUCCESS';
export const WELL_INFO_UPDATE_ERROR = 'WELL_INFO_UPDATE_ERROR';

export const WELL_INFO_UPDATE_DATA = 'WELL_INFO_UPDATE_DATA';